export default __webpack_public_path__ + "static/media/safari2.80c76b70.jpg";